import { css } from '@emotion/react'

export const form = () => css`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const input = css`
  width: 100%;

  & > label {
    gap: 14px;
  }
`
